import { Box, Icon, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

import { type DisplayMode, displayModePreferenceForMode } from "~/helpers/displayModePreference";
import useDisplayModePreference from "~/hooks/useDisplayModePreference";

const segments: { icon: string; labelKey: string; mode: DisplayMode }[] = [
	{ icon: "smartphone", labelKey: "shell.displayModeSwitcher.mobile", mode: "mobile" },
	{ icon: "devices", labelKey: "shell.displayModeSwitcher.default", mode: "auto" },
	{ icon: "desktop_windows", labelKey: "shell.displayModeSwitcher.desktop", mode: "desktop" }
];

const DisplayModeSwitcher = () => {
	const { t } = useTranslation("common");
	const [preference, savePreference] = useDisplayModePreference();

	const handleChange = (_event: React.MouseEvent<HTMLElement>, mode: DisplayMode | null) => {
		if (!mode || mode === preference.mode) return;
		savePreference(displayModePreferenceForMode(mode));
	};

	return (
		<Box sx={{ px: 2, py: 0.75 }}>
			<ToggleButtonGroup
				aria-label={t("shell.displayModeSwitcher.groupAria")}
				color="primary"
				exclusive
				fullWidth
				onChange={handleChange}
				size="small"
				value={preference.mode}
			>
				{segments.map((segment) => (
					<ToggleButton aria-label={t(segment.labelKey)} key={segment.mode} sx={{ gap: 0.5 }} value={segment.mode}>
						<Icon fontSize="small">{segment.icon}</Icon>
						{t(segment.labelKey)}
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</Box>
	);
};

export default DisplayModeSwitcher;
